export default "__VITE_ASSET__DzZQ1AHx__"